import { CommonModule } from '@angular/common';
import {
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';

export interface PillToggleOption {
	value: string;
	label: string;
	class?: string;
}

@Component({
	standalone: true,
	selector: 'pill-toggle',
	templateUrl: './pill-toggle.component.html',
	styleUrls: ['./pill-toggle.component.scss'],
	imports: [MatButtonToggleModule, CommonModule, TranslateModule]
})
export class PillToggleComponent {
	@Output() public onOptionSelect = new EventEmitter<string>();
	@Input() public options: PillToggleOption[] = [];
	@Input() public selectedOption: string | null = null;
	@Input() public ariaLabel: string = 'pill-toggle_aria-label';
}
